<template>
  <div class="detail">
    <sr-loading v-if="loading"/>
    <div v-else>
      <sr-top :data="DATA"/>
      <sr-content :data="DATA"/>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import SrTop from './sr-top'
  import SrContent from './sr-content'
  import SrLoading from '@/components/loading'
  export default {
    components: {
      SrTop,
      SrContent,
      SrLoading
    },
    data () {
      return {
        loading: true,
        DATA: {}
      }
    },
    methods: {
      getInfo () {
        this.loading = true
        axios.post('/node/api/restaurant/info', {
          storeId: this.$route.params.id,
          spotX: 38.8,
          spotY: 116
        }).then(res => {
          if (res.data.code === 9999) {
            this.DATA = res.data
            this.loading = false
            document.title = this.DATA.info.shopName + ' - 耀莱在线'
          }
        })
      }
    },
    created () {
      this.getInfo()
    },
    watch: {
      '$route' () {
        this.getInfo()
      }
    }
  }
</script>

<style lang="less" scoped>
  .detail {
    width: 1200px;
    margin: 0 auto;
    .param {
      padding: 20px 30px;
      background-color: white;
      border: 1px solid #eee;
      .name {
        padding-bottom: 20px;
        text-align: center;
        font-weight: bold;
        font-size: 16px;
        color: #333;
      }
      .list {
        overflow: hidden;
        font-size: 12px;
        li {
          float: left;
          width: 33.333%;
          list-style: none;
        }
        p {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          margin-right: 2em;
        }
      }
      
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/restaurant-detail/index.vue